import { useDispatch } from "react-redux";
import AbscondingRunWayList from "./AbscondingRunWayList";

export default function AbscondingRunWayTab({
  globalData,
  setTrigger,
  trigger,
}) {
  return (
    <div className={`p-2 `}>
      <AbscondingRunWayList
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
